"use client";
import { fetchLatestArticles, fetchContentfulTags } from "./contentful";
export const clientFetchLatestArticles = fetchLatestArticles;
export const clientFetchContentfulTags = fetchContentfulTags;
